import React from "react";
import { ElementGroup } from '@whalecloud/page-builder-core/constant';
import Tree from "./components/Tree";
import TreeSettings from "./components/TreeSettings";
import { ReactComponent as PluginSvg } from "@assets/icons/tree_settings.svg";
import { getLocale, defaultTarget, treeDataSource } from '@utils/util';

export default () => {
  const messages = getLocale();
  return {
    name: 'tree',
    group: ElementGroup.COMPLEX,
    target: defaultTarget,
    title: messages['PAGEBUIDER_ELEMENT_FORM_TREE'],
    toolBarPreview: <PluginSvg />,
    data: {
      formItemSettings: {
        treeData: treeDataSource,
        checkable: false,
        autoInitialize: true,
        defaultExpandedKeys: ['0-0-0'],
        url: {
          url: 'https://mock.iwhalecloud.com/mock/1889/api/treedata'
        }
      },
      formSettings: {
        label: messages['PAGEBUIDER_ELEMENT_FORM_TREE']
      },
      settings: {
        margin: {
          mobile: { all: 0 },
          desktop: { all: 10 },
          advanced: true
        },
        padding: {
          mobile: { top: 15, left: 15, right: 15, bottom: 15 },
          desktop: { top: 0, left: 25, right: 25, bottom: 0 },
        },
        width: {
          value: "100%"
        },
        height: {
          value: "150px"
        },
      }
    },
    pluginComponent: Tree, // 插件渲染组件
    pluginSettingComponent: TreeSettings, // 插件设置项组件
  }
}
